import React, { useState } from "react";

import { useHistory } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { axiosAuth } from "react-axios";
import queryString from "query-string";
import Spinner from "react-bootstrap/Spinner";
import { userPasswordReset } from "~/api/getUser";
import { LOCAL_STORE_JWT } from "~/utils/main";

import { useUser } from "~/Context/userContext";

import styled from "styled-components";

export const FormWrapper = styled.section`
  margin-top: 20px;
  margin-bottom: 10px;
  label {
    width: 160px;
  }
  input {
    width: 220px;
  }
`;

const useResetForm = (initialValues, callback) => {
  const [inputs, setInputs] = useState(initialValues);
  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    callback();
  };
  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };
  return {
    handleSubmit,
    handleInputChange,
    inputs,
  };
};

const UserPasswordResetPage = (props) => {
  let history = useHistory();
  const { state: userState, dispatch } = useUser();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const queryParams = queryString.parse(props.location.search);
  const { token = "", userId = "" } = queryParams;

  const registerCb = () => {
    setLoading(true);
    const payload = { ...inputs, token, userId };
    console.log("payload:", payload);
    userPasswordReset(axiosAuth, payload)
      .then(({ data: { success, isChim, jwt, error_type = "", user = {} } }) => {
        console.log("data success:", success);
        console.log("error_type:", error_type);
        setLoading(false);
        localStorage.setItem(LOCAL_STORE_JWT, jwt);
        console.log("user:", user);
        dispatch({ type: "user_login", payload: { user } });
        // history.push(`/`);
      })
      .catch((e) => {
        console.log("reset error", e);
        if (e.response && e.response.data && e.response.data.message) {
          setErrorMsg(e.response.data.message);
        } else {
          setErrorMsg(`There was an error with the password reset, please try again.`);
        }
        setHasError(true);
        setLoading(false);
      });
  };

  if (userState.loggedin || !userId || !token) {
    history.push(`/`);
  }
  const { inputs, handleInputChange, handleSubmit } = useResetForm({ password1: "", password2: "" }, registerCb);
  // if (userState.loggedin) {
  //   return null;
  // }
  return (
    <div className="totd-page-general user-profile-page">
      <h3>Reset your password:</h3>
      <p>* must be at least 6 chars using letters and/or numbers</p>
      <div>
        <div>
          {loading && <Spinner animation="border" variant="secondary" />}
          {hasError && <div className="error-msg">{errorMsg}</div>}
        </div>
        <Form className="pwd-reset-form" noValidate onSubmit={handleSubmit}>
          <FormWrapper>
            <div>
              <label>New Password</label>
              <input type="password" name="password1" onChange={handleInputChange} value={inputs.password1} required maxlength="30" />
            </div>
            <div>
              <label>Re-enter Password</label>
              <input type="password" name="password2" onChange={handleInputChange} value={inputs.password2} required maxlength="30" />
            </div>
            <Button style={{ padding: "5px 20px", margin: "6px 0 0 0" }} variant="secondary" size="sm" type="submit">
              Reset Password &amp; Login
            </Button>
          </FormWrapper>
        </Form>
      </div>
    </div>
  );
};

export default UserPasswordResetPage;
